module.exports = __webpack_public_path__ + "img/logo.537d90e1.svg";